import { render, staticRenderFns } from "./ModalData.vue?vue&type=template&id=65c87cfa&scoped=true"
import script from "./ModalData.vue?vue&type=script&lang=js"
export * from "./ModalData.vue?vue&type=script&lang=js"
import style0 from "./ModalData.vue?vue&type=style&index=0&id=65c87cfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c87cfa",
  null
  
)

export default component.exports